module.exports = __webpack_public_path__ + "static/media/004.00c8c39d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/004.jpg
// module id = 548
// module chunks = 0